@if (searchService.searchError$ | async; as error) {
  <rotec-service-error-v2> </rotec-service-error-v2>
} @else {
  <div class="header-row">
    <rotec-radio-row-v2
      [options]="searchService.responsibleCompanyOptions"
      [selected]="state.responsibleCompanyFilterValue"
      [spaceEvenly]="true"
      (selectedChange)="searchService.filterForResponsible($event)"
    ></rotec-radio-row-v2>
  </div>
  <div class="task-search">
    <rotec-default-grid-v2
      [columns]="state.columns"
      [height]="gridHeight"
      (columnsChange)="updateColumnSettings($event)"
      [data]="state.searchData"
      (stateChange)="refineSearch($event)"
      (pageSizeChanged)="reactToPageSizeChange($event)"
      [controlButtons]="controlButtons"
      [selectConfig]="{
        checkboxAlwaysVisible: true,
        checkboxToggleOnWholeRow: false,
      }"
      [selectedResults]="state.searchData.selectedIds"
      [noDataText]="noDataText"
      (selectedResultsChange)="searchService.setSelectedResults($event)"
      (selectedItemChanged)="toggleSelectedItem($event)"
      (rowClick)="openTask($event)"
      [fixedSpinner]="true"
      [filterButton]="false"
      (fulltextSearchChanged)="keyupEnterSearch($event)"
    >
      <ng-template rotecGridCellV2="undo" let-dataItem="dataItem">
        @if (
          !isReactivateBtnDisabled(dataItem) && (userRightsService.hasActionRights$('Add') | async)
        ) {
          <p
            class="grid-text-cell"
            [class.disabled]="undoLoadingState.has(dataItem)"
            (click)="undoTask(dataItem, $event)"
          >
            <rotec-icon-v2 fontIcon="icon-undo2"></rotec-icon-v2>
          </p>
        }
      </ng-template>
      <ng-template rotecGridCellV2="plantName" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.plantName || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="machineName" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.machineName || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="machineSerial" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.machineSerial || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="schenckId" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.schenckId || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="customerId" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.customerId || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="title" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.title || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="priority" let-dataItem="dataItem">
        <ma-priority
          class="grid-text-cell"
          [priority]="dataItem.priority"
          [isSelected]="isSelected(dataItem.id)"
        ></ma-priority>
      </ng-template>
      <ng-template rotecGridCellV2="responsibleCompany" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.responsibleCompany || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="responsible" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.responsible || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="executive" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.executive || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="executionDate" let-dataItem="dataItem">
        <ma-execution-date
          [date]="dataItem.executionDate"
          [isSelected]="isSelected(dataItem.id)"
        ></ma-execution-date>
      </ng-template>
      <ng-template rotecGridCellV2="dueDate" let-dataItem="dataItem">
        <ma-date
          class="grid-text-cell"
          [date]="dataItem.dueDate"
          [isSelected]="isSelected(dataItem.id)"
        ></ma-date>
      </ng-template>
      <ng-template rotecGridCellV2="description" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.description || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="component" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.component || '-' | taskComponent }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="type" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.type | typeEnum }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="requiredTooling" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.requiredTooling || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="possibleSpareParts" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.possibleSpareParts || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="expectedDurationMinutes" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.expectedDurationMinutes || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="scheduling" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.scheduling | taskInterval }}</p>
      </ng-template>
    </rotec-default-grid-v2>
  </div>
}
